import React, { useCallback, useEffect, useRef, useState } from 'react'
import { FormControl, FormGroup, FormLabel, IconButton, MenuItem, TextField } from '@mui/material'
import { useForm, Controller } from 'react-hook-form';
import ProfileAvatar from '../../../component/ProfileAvatar/ProfileAvatar';

import { useAuth } from '../../../hooks/AuthContext';
import { doc, onSnapshot } from "firebase/firestore";
import { database } from '../../../firebase';

import { DevTool } from '@hookform/devtools';
import { ArrowBackIos } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import PageHeadingLabel from '../../../component/PageHeadingLabel/PageHeadingLabel';
import { setDoc, updateDoc, getDoc, } from "firebase/firestore";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { v4 as uuidv4 } from 'uuid';
import { storage } from '../../../firebase';
import "./StartupIdentity.css"
import PageTopComponent from '../../../component/PageTopComponent/PageTopComponent';
import LabelBackButton from '../../../component/LabelBackButton';
import { useMediaQuery } from 'react-responsive';
import UploadDialog from '../../../component/UploadDialog/UploadDialog';


export default function StartupIdentity() {
    const [fileName, setFileName] = useState("");
    const [file, setFile] = useState(null);
    const { currentUser } = useAuth();
    const [dataLoading, setDataLoading] = useState(true);
    const [open, setOpen] = useState(false);

    const navigate = useNavigate()

    const isMobile = useMediaQuery({ query: '(max-width: 576px)' })








    const hiddenFileInput = useRef(null);

    // Programatically click the hidden file input elements
    // when the Button component is clicked
    const handleClick = (event) => {
        hiddenFileInput.current.click();
    };
    // Call a function (passed as a prop from the parent component)
    // to handle the user-selected file
    // const handleChange = (e) => {
    //     const selectedFile = e.target.files[0];
    //     setFile(selectedFile);
    //     if (selectedFile) {
    //         setFileName(URL.createObjectURL(selectedFile));
    //     }
    //     handleFileUploadToFirebaseStorage()
    // };


    function getCurrentDate() {
        const date = new Date();

        let day = date.getDate();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();

        let currentDate = `${day}/${month}/${year}`;
        console.log(currentDate);
        return currentDate;
    }



    const countries = [
        "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica", "Cote d'Ivoire", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Fiji", "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, North", "Korea, South", "Kosovo", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Macedonia", "Norway", "Oman", "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
    ];

    const platformTypes = [
        "Web Applications",
        "Mobile Applications (iOS/Android)",
        "Desktop Applications",
        "E-commerce Platforms",
        "Social Media Platforms",
        "Content Management Systems",
        "Blockchain Platforms",
        "Artificial Intelligence and Machine Learning",
        "Internet of Things (IoT) Devices",
        "Augmented Reality (AR) / Virtual Reality (VR) Apps",
        "Cloud Computing Services",
        "Healthcare Technology",
        "Financial Technology (Fintech)",
        "Gaming Platforms",
        "Educational Technology (EdTech)",
        "SaaS (Software as a Service)",
        "Marketplace Platforms",
        "Data Analytics and Business Intelligence",
        "Cybersecurity Solutions",
        "Robotics and Automation",
        "Smart Home Devices",
        "Travel and Hospitality Platforms",
        "Environmental and Sustainability Solutions"
    ];


    const customerTypes = [
        "Individual Consumers",
        "Small Businesses",
        "Medium-sized Businesses",
        "Large Enterprises",
        "Government Organizations",
        "Non-profit Organizations",
        "Educational Institutions",
        "Healthcare Providers",
        "Retailers",
        "Manufacturers",
        "Service Providers",
        "Freelancers",
        "Creative Professionals",
        "Tourists",
        "Travelers",
        "Students",
        "Developers",
        "Gamers",
        "Investors",
        "Researchers",
        "Sports Enthusiasts",
        "Fitness Enthusiasts",
        "Tech Enthusiasts",
        "Art Enthusiasts",
        "Food Enthusiasts",
        "Music Enthusiasts",
        "Book Lovers",
        "Fashion Enthusiasts",
        "Homeowners",
        "Pet Owners",
        "Environmentalists",
        "Parents",
        "Children",
        "Seniors",
        "Event Organizers",
        "Marketers",
        "Sales Professionals",
        "Trainers and Coaches",
        "Consultants",
        "Drivers",
        "Travel Agencies",
        "Real Estate Agents",
        "Artists",
        "Musicians",
        "Filmmakers",
        "Photographers",
        "Writers",
        "Bloggers",
        "Influencers",
        "Collectors",
        "Gardeners",
        "Tech Startups",
        "Health and Wellness Startups",
        "Education Startups",
        "E-commerce Startups",
        "Social Enterprises",
        "Subscription Box Services",
        "Subscription Streaming Services",
        "Remote Workers",
        "Digital Nomads",
        "DIY Enthusiasts"
    ];


    const sectors = [
        "Technology",
        "Healthcare",
        "Finance",
        "Education",
        "Manufacturing",
        "Retail",
        "Hospitality and Tourism",
        "Real Estate",
        "Transportation and Logistics",
        "Energy",
        "Media and Entertainment",
        "Telecommunications",
        "Agriculture",
        "Automotive",
        "E-commerce",
        "Gaming",
        "Environmental and Sustainability",
        "Government and Public Sector",
        "Non-profit and Charity",
        "Professional Services",
        "Consulting",
        "Legal",
        "Marketing and Advertising",
        "Food and Beverage",
        "Fashion and Apparel",
        "Art and Culture",
        "Sports and Fitness",
        "Pharmaceuticals",
        "Biotechnology",
        "Construction",
        "Insurance",
        "Aviation",
        "Space and Aerospace",
        "Maritime and Shipbuilding",
        "Mining and Minerals",
        "Social Services",
        "Research and Development",
        "Internet Services",
        "Software Development",
        "Hardware Manufacturing",
        "Health and Wellness",
        "Information Technology",
        "Renewable Energy",
        "Cybersecurity",
        "AI and Machine Learning",
        "Blockchain",
        "Robotics",
        "Virtual Reality (VR) and Augmented Reality (AR)"
    ];

    // const handleFileUploadToFirebaseStorage = () => {
    //     if (file) {
    //         // Create a storage reference to the file
    //         const filePath = `users/${currentUser.email}/startupInformation/identity/${file.name}_${uuidv4()}`;
    //         const storageRef = ref(storage, filePath);
    //         const uploadTask = uploadBytesResumable(storageRef, file,);

    //         // Listen for state changes, errors, and completion of the upload.
    //         uploadTask.on('state_changed',
    //             (snapshot) => {
    //                 // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
    //                 const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

    //                 //  setFileUploadProgress(progress);

    //                 console.log('Upload is ' + progress + '% done');
    //                 switch (snapshot.state) {
    //                     case 'success':

    //                         console.log('Upload is completed');
    //                         break;
    //                     case 'paused':
    //                         console.log('Upload is paused');
    //                         break;
    //                     case 'running':
    //                         console.log('Upload is running');
    //                         break;
    //                     default:
    //                         console.log("nothn")
    //                 }
    //             },
    //             (error) => {
    //                 // A full list of error codes is available at
    //                 // https://firebase.google.com/docs/storage/web/handle-errors
    //                 switch (error.code) {
    //                     case 'storage/unauthorized':
    //                         // User doesn't have permission to access the object
    //                         break;
    //                     case 'storage/canceled':
    //                         // User canceled the upload
    //                         break;



    //                     case 'storage/unknown':
    //                         // Unknown error occurred, inspect error.serverResponse
    //                         break;
    //                     default:
    //                         console.log("noth");
    //                 }
    //             },
    //             async () => {
    //                 // Upload completed successfully, now we can get the download URL
    //                 getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
    //                     console.log('File available at', downloadURL);

    //                     debouncedAddToFirestore("fileUrl", downloadURL);



    //                 });



    //             }

    //         );


    //     } else {
    //         console.error('No file selected');
    //     }
    // };



    const { control, formState: { errors }, setValue } = useForm({
    });


    const fetchIdentityData = useCallback(async () => {
        const identityRef = doc(database, "startupInformation", currentUser.uid, "startupIdentity", "identity");
  
        onSnapshot(identityRef, (docSnap) => {
            if (docSnap.exists()) {
                console.log("Document data:", docSnap.data());
    
                setValue("name", docSnap.data().name)
                setValue("startupOneliner", docSnap.data().startupOneliner)
                setValue("startupWebsite", docSnap.data().startupWebsite)
                setValue("startupCountry", docSnap.data().startupCountry)
                setValue("startupPlatformType", docSnap.data().startupPlatformType)
                setValue("startupCustomerType", docSnap.data().startupCustomerType)
                setValue("startupSector", docSnap.data().startupSector)
                setValue("fileUrl", docSnap.data().fileUrl)
    
                setFileName(docSnap.data().fileUrl);
    
                setDataLoading(false)
    
            } else {
                 setDoc(identityRef, { "name": "" }).then((e)=>{});
            }
        });   
       
    }, [])



    useEffect(() => {
        fetchIdentityData();
    }, [fetchIdentityData])


    const debounce = (func, delay) => {
        let timeoutId;
        return (...args) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func(...args);
            }, delay);
        };
    };

    const addToFirestore = async (valueKey, value) => {
        console.log("valueKey " + valueKey + " value " + value);
        const identityRef = doc(database, "startupInformation", currentUser.uid, "startupIdentity", "identity");

        await updateDoc(identityRef, {
            [valueKey]: value,
        });
    };


    const handleCountryChange = (key, value) => {
        debouncedAddToFirestore(key, value)
    };

    const debouncedAddToFirestore = debounce(addToFirestore, 1000);


    const handleUploadDialog =( event, reason) => {
    
        if (reason && reason === "backdropClick") {
          return;
        }
       
    
    
    
      setOpen(open=>!open);
    };



    return (
        <>
            {/* <DevTool control={control} placement="top-right" /> */}
            <LabelBackButton title={"Startup Identity"} />
            <UploadDialog open={open} onClose={handleUploadDialog} />
            <br/>
            <ProfileAvatar onEdit={handleUploadDialog} fileURL={fileName ? fileName : process.env.PUBLIC_URL + "/pic/user_profile.png" } />


            {/* <div style={{ display: "inline-flex", alignItems: "center", marginTop: "1rem" }}>

                <img
                    onClick={handleClick}
                    style={{ display: "inline", marginRight: "1rem", maxWidth: "100%", maxHeight: "100%" }}
                    className="user-profile-pic"

                    src={fileName ? fileName : process.env.PUBLIC_URL + "/pic/user_profile.png"}
                    alt="profile" />
                <input
                    type="file"
                    onChange={handleChange}
                    ref={hiddenFileInput}
                    style={{ display: "none" }} />
                <span >Startup Logo</span>
            </div> */}
            <div style={{ display: "flex", flexDirection: "column", marginTop: "2rem" }}>

                <FormControl  >

                    <FormGroup >
                        <FormLabel
                            sx={{ color: "black", fontFamily: 'mdsans', fontSize: "0.9rem" }}>Startup Name</FormLabel>

                        <Controller
                            name="name"
                            control={control}
                            defaultValue=""
                            rules={{ required: 'Startup Name is required' }}
                            render={({ field }) => <TextField {...field}
                                error={!!errors.name}
                                onKeyUp={() => debouncedAddToFirestore("name", field.value)}

                                fullWidth sx={{ borderRadius: "10px", width:isMobile ? "100%": "40%", marginTop: "0.5rem" }} type="text" placeholder="Startup name" />}
                        />
                        {errors.startupName && <p className="error-text">{errors.startupName.message}</p>}
                    </FormGroup>
                    <br />
                    <FormGroup >
                        <FormLabel sx={{ color: "black", fontFamily: 'mdsans', fontSize: "0.9rem" }}>Startup One Liner</FormLabel>

                        <Controller
                            name="startupOneliner"
                            control={control}
                            defaultValue=""
                            rules={{ required: 'Startup One Liner is required' }}
                            render={({ field }) => <TextField {...field}
                                onKeyUp={() => debouncedAddToFirestore("startupOneliner", field.value)}

                                fullWidth sx={{ borderRadius: "10px", width:isMobile ? "100%": "80%", marginTop: "0.5rem" }} type="text" placeholder="Startup name" />}
                        />
                        {errors.startupOneliner && <p className="error-text">{errors.startupOneliner.message}</p>}
                    </FormGroup>
                    <br />
                    <FormGroup >
                        <FormLabel sx={{ color: "black", fontFamily: 'mdsans', fontSize: "0.9rem" }}>Startup Website</FormLabel>

                        <Controller
                            name="startupWebsite"
                            control={control}
                            defaultValue=""
                            rules={{ required: 'Startup Website is required' }}
                            render={({ field }) => <TextField {...field}
                                onKeyUp={() => debouncedAddToFirestore("startupWebsite", field.value)}

                                fullWidth sx={{ borderRadius: "10px", width:isMobile ? "100%": "40%", marginTop: "0.5rem" }} type="text" placeholder="Startup name" />}
                        />
                        {errors.startupWebsite && <p className="error-text">{errors.startupWebsite.message}</p>}
                    </FormGroup>
                    <br />
                    <FormGroup >
                        <FormLabel sx={{ color: "black", fontSize: "0.9rem" }}>Startup Country</FormLabel>
                        <Controller
                            name="startupCountry"
                            control={control}
                            defaultValue=""
                            rules={{ required: 'Country is required' }}
                            render={({ field }) => <TextField {...field}
                                onChange={(e) => {
                                    field.onChange(e);
                                    handleCountryChange("startupCountry", e.target.value);
                                }}
                                select
                                fullWidth sx={{ borderRadius: "10px", width:isMobile ? "100%": "40%", marginTop: "0.5rem" }} type="text" placeholder="Select Country" >
                                {countries.map((country) => (
                                    <MenuItem key={country} value={country}>
                                        {country}
                                    </MenuItem>
                                ))}
                            </TextField>}
                        />

                        {errors.startupCountry && <p className="error-text">{errors.startupCountry.message}</p>}
                    </FormGroup>
                    <br />
                    <FormGroup >
                        <FormLabel sx={{ color: "black", fontFamily: 'mdsans', fontSize: "0.9rem" }}>Platform Type</FormLabel>
                        <Controller
                            name="startupPlatformType"
                            control={control}
                            defaultValue=""
                            rules={{ required: 'Platform is required' }}
                            render={({ field }) => <TextField {...field}
                                onChange={(e) => {
                                    field.onChange(e);
                                    handleCountryChange("startupPlatformType", e.target.value);
                                }}
                                select
                                fullWidth sx={{ borderRadius: "10px", width:isMobile ? "100%": "40%", marginTop: "0.5rem" }} type="text" placeholder="Select Platform" >
                                {platformTypes.map((type) => (
                                    <MenuItem key={type} value={type}>
                                        {type}
                                    </MenuItem>
                                ))}
                            </TextField>}
                        />
                        {errors.startupPlatformType && <p className="error-text">{errors.startupPlatformType.message}</p>}
                    </FormGroup>
                    <br />
                    <FormGroup >
                        <FormLabel sx={{ color: "black", fontFamily: 'mdsans', fontSize: "0.9rem" }}>Customer Type</FormLabel>
                        <Controller
                            name="startupCustomerType"
                            control={control}
                            defaultValue=""
                            rules={{ required: 'Customer Type is required' }}
                            render={({ field }) => <TextField {...field}
                                onChange={(e) => {
                                    field.onChange(e);
                                    handleCountryChange("startupCustomerType", e.target.value);
                                }}
                                select
                                fullWidth sx={{ borderRadius: "10px", width:isMobile ? "100%": "40%", marginTop: "0.5rem" }} type="text" placeholder="Select Platform" >
                                {customerTypes.map((customerType) => (
                                    <MenuItem key={customerType} value={customerType}>
                                        {customerType}
                                    </MenuItem>
                                ))}
                            </TextField>}
                        />

                        {errors.startupCustomerType && <p className="error-text">{errors.startupCustomerType.message}</p>}
                    </FormGroup>
                    <br />
                    <FormGroup >
                        <FormLabel sx={{ color: "black", fontFamily: 'mdsans', fontSize: "0.9rem" }}>Sector</FormLabel>
                        <Controller
                            name="startupSector"
                            control={control}
                            defaultValue=""
                            rules={{ required: 'Sector is required' }}
                            render={({ field }) => <TextField {...field}
                                onChange={(e) => {
                                    field.onChange(e);
                                    handleCountryChange("startupSector", e.target.value);
                                }}
                                select
                                fullWidth sx={{ borderRadius: "10px", width:isMobile ? "100%": "40%", marginTop: "0.5rem" }} type="text" placeholder="Select Platform" >
                                {sectors.map((sec) => (
                                    <MenuItem key={sec} value={sec}>
                                        {sec}
                                    </MenuItem>
                                ))}
                            </TextField>}
                        />
                        {errors.startupSector && <p className="error-text">{errors.startupSector.message}</p>}
                    </FormGroup>
                </FormControl>

            </div>

        </>
    )
}
